import { register } from 'async-ops';
import { getDefaultOptions, throwExceptionErrors } from '../../../utils/fetch';
import { callMdaePublicApi } from "../../../call-web-api";

export const SAVE_USER_DOCUMENTS = 'SAVE_USER_DOCUMENTS';

export const service = async (data) => {
  const response: any = await callMdaePublicApi({
    type: 'post',
    contentType: 'application/json',
    url: '/Api/Document/SaveDocument',
    isRoutedApiCall: true,
    ...getDefaultOptions(),
    body: JSON.stringify(data)
  })
  throwExceptionErrors(response);
  
  return response;

};

const mockData = () => {
  return ([])
};

const mock = () => Promise.resolve(mockData());

register(SAVE_USER_DOCUMENTS, service, mock);
